export const INITIAL_STATE = {
    section_1: {
        title: null,
        description: null,
    },
    section_2: {
        title: null,
        description: null,
    },
    section_3: {
        title: null,
        description: null,
    },
}

export const GET_FIELD_NAME = {
    section_1: { title: 'Title section' },
    section_2: { title: 'Title section' },
    section_3: { title: 'Title section' },
}

export const FIELD_NAME_DETAIL = {
    section_1: { ...GET_FIELD_NAME?.section_1, description: 'description' },
    section_2: { ...GET_FIELD_NAME?.section_2, description: 'description' },
    section_3: { ...GET_FIELD_NAME?.section_3, description: 'description' },
}
